module.exports = __webpack_public_path__ + "static/media/vinglabs_accuracy_color_transparent.27eeda23.png";